export default __webpack_public_path__ + "static/media/sara.fd21826b.png";